<template>
  <div class="dialog-layout layout-border-flex">
    <div class="header layout-flex-around" v-if="title || $slots.header">
      <slot name="header">
        <span class="title">{{title}}</span>
        <div class="extra" v-if="$slots.extra">
          <slot name="extra"></slot>
        </div>
      </slot>
    </div>
    <div class="main layout-flex-center">
      <div class="main-cont"
           :class="{'auto-height': autoHeight}">
        <slot></slot>
      </div>
    </div>
    <div class="footer layout-flex-around" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogLayout',
  props: {
    title: String,
    autoHeight: Boolean
  }
}
</script>

<style lang="scss">
  .dialog-layout {
    position: relative;
    height: 100%;
    & > .header {
      position: relative;
      height: 40px;
      background-color: #fff;
      line-height: 38px;
      border-bottom: 1px solid rgba(0,0,0,.05);
      padding-left: 10px;
      padding-right: 10px;
      & > .title {
        font-size: 13px;
      }
      & > .extra {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -2px;
        transform: translateY(-50%);
      }
    }
    & > .main {
      position: relative;
      & > .main-cont {
        &:not(.auto-height) {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
